<template>
    <div class="login-modal error-modal" style="display: flex; z-index: 10000">
        <div class="modal1_content-wrapper-long alt mobile-height">
            <div class="modal-content">
                <a-result status="warning" title="Check Your Connection" sub-title="It looks like you're not connected to the internet. Please check your connection and try again.">
                    <template #extra>
                        <div class="error-modal-buttons">
                            <button 
                                @click="tryAgain" 
                                class="button form_button w-button error-modal-btn"
                            >
                                Try Again
                            </button>
                        </div>
                    </template>
                </a-result>
            </div>
        </div>
        <div class="modal1_background-overlay color"></div>
    </div>
</template>
<script>
export default {
    mounted() {
        // Listen for online event to auto-dismiss when connection is restored
        globalThis.addEventListener('online', this.onConnectionRestored);
    },
    beforeUnmount() {
        // Clean up event listener
        globalThis.removeEventListener('online', this.onConnectionRestored);
    },
    methods: {
        onConnectionRestored() {
            this.tryAgain();
        },
        tryAgain() {
            // Remove the error modal container before reloading
            const container = document.getElementById('connectivity-error-container');
            if (container) {
                document.body.style.overflow = '';
                container.remove();
            }
            globalThis.location.reload();
        },
    },
};
</script>
<style src="./error-modal.css"></style>
